module.exports = __webpack_public_path__ + "static/img/4932_phase_function_Paper_Points.1969f4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4932_phase_function_Paper_Points.png
// module id = 6/fy
// module chunks = 0